module.exports = __webpack_public_path__ + "static/img/comfirm0.8d667d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hongbao/img/comfirm0.png
// module id = CER1
// module chunks = 1